import {createContext} from 'react';

const productsContext = createContext([false, () => {
}]);
export default productsContext;
